document.addEventListener('click',event=>{
  const menuButton=event.target.closest('[data-menu-toggle]');
  if(menuButton){const nav=document.querySelector('[data-nav]');nav?.classList.toggle('open');menuButton.setAttribute('aria-expanded',nav?.classList.contains('open')?'true':'false');}
  const thumb=event.target.closest('[data-product-thumb]');
  if(thumb){const root=thumb.closest('[data-product-root]');showProductImage(root,thumb);root?.restartProductAutoplay?.();}
});

addEventListener('scroll',()=>document.querySelector('.header')?.classList.toggle('scrolled',scrollY>10),{passive:true});

document.addEventListener('change',event=>{
  if(event.target.name==='purchase_type'||event.target.name==='selling_plan')event.target.closest('.purchase-options')?.querySelectorAll('.purchase-card').forEach(card=>card.classList.toggle('selected',card.contains(event.target)));
});

function showProductImage(root,thumb){
  const main=root?.querySelector('[data-main-image]');
  if(!main||!thumb?.dataset.image)return;
  main.classList.add('changing');
  const nextImage=new Image();
  nextImage.onload=()=>{main.src=thumb.dataset.image;main.classList.remove('changing');};
  nextImage.onerror=()=>main.classList.remove('changing');
  nextImage.src=thumb.dataset.image;
  root.querySelectorAll('[data-product-thumb]').forEach(item=>item.classList.toggle('active',item===thumb));
  if(typeof thumb.scrollIntoView==='function')thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
}

function startProductAutoplay(root){
  if(!root||root.dataset.autoplayReady==='true')return;
  const thumbs=[...root.querySelectorAll('[data-product-thumb]')];
  if(thumbs.length<2)return;
  root.dataset.autoplayReady='true';
  let index=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('active')));
  let timer;
  const play=()=>{clearInterval(timer);timer=setInterval(()=>{index=(index+1)%thumbs.length;showProductImage(root,thumbs[index]);},3000);};
  root.restartProductAutoplay=play;
  root.addEventListener('mouseenter',()=>clearInterval(timer));
  root.addEventListener('mouseleave',play);
  root.addEventListener('touchstart',()=>clearInterval(timer),{passive:true});
  root.addEventListener('touchend',play,{passive:true});
  root.addEventListener('focusin',()=>clearInterval(timer));
  root.addEventListener('focusout',play);
  play();
}

function initializeProductSliders(scope=document){scope.querySelectorAll('[data-product-root]').forEach(startProductAutoplay);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeProductSliders());else initializeProductSliders();
document.addEventListener('shopify:section:load',event=>initializeProductSliders(event.target));
